import { render, staticRenderFns } from "./imputation-recap-list.vue?vue&type=template&id=5fdfb19a&"
import script from "./imputation-recap-list.vue?vue&type=script&lang=ts&"
export * from "./imputation-recap-list.vue?vue&type=script&lang=ts&"
import style0 from "./imputation-recap-list.vue?vue&type=style&index=0&id=5fdfb19a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports